import { FC, ReactNode } from "react";

interface RequirementDescProps {
  key: string;
  label: string;
  children: ReactNode
}

const RequirementDescChild: FC<RequirementDescProps> = ({
  key, label, children
}) => {

  return (

    <div
      key={key}
      style={{
        display: "flex",
        alignItems: "center", // 垂直居中
        gap: "8px", // 标签和内容之间的间距
        flex: "1 1 auto", // 自动调整宽度
        minWidth: "200px", // 最小宽度，防止内容过窄
      }}
    >
      <div style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
        {label}:
      </div>
      <div style={{ maxWidth: "85%" }}>{children}</div>
    </div>

  );
};

export default RequirementDescChild;